export default __webpack_public_path__ + "static/media/Netflix.7b32de83.png";